export { default as NavBarProperties } from './NavBarProperties'